document.querySelectorAll('[data-add-btn]').forEach((btn) => {
  btn.addEventListener('click', (e) => {
    e.preventDefault(); // prevent default action if it's a link or submit

    const target = document.querySelector('.tt-product-single-info');
    if (target) {
      target.scrollIntoView({
        behavior: 'smooth',
        block: 'start' // aligns at the top of viewport
      });
    }
  });
});

$(document).ready(function() {
    // Loop through all your "Jump To" links
    $('.showlink a').each(function() {
        var linkText = $(this).text().trim(); // Get the text of the link
        // Find the first <h2> that contains this text
        var targetHeading = $('h2').filter(function() {
            return $(this).text().trim().indexOf(linkText) !== -1;
        }).first();

        if(targetHeading.length) {
            // Add click handler to scroll smoothly
            $(this).on('click', function(e) {
                e.preventDefault();
                $('html, body').animate({
                    scrollTop: targetHeading.offset().top
                }, 600);
            });
        }
    });
});

jQuery(document).ready(function ($) {
  var $menuBtn = $("#menuBtn");
  var $target = $(".table-content");

  if ($menuBtn.length && $target.length) {
    $menuBtn.on("click", function () {
      $("html, body").animate(
        {
          scrollTop: $target.offset().top
        },
        600
      );
    });
  }
});
